export const bussConfig = {
  patient: {
    title: '患者协同备注',
    label: '协同备注',
    tips: '若你有需要BD注意的信息，可以填写备注信息给BD知晓，BD也可以同步信息给你知晓。',
    placeholder: '输入协同备注后，能同步给BD知晓',
    keyword: '', // 输入框关键字
    maxLength: 200, // 最大字数限制
    allowClear: false //是否允许清除
  },
  doctor: {
    title: '医生协同备注',
    label: '协同备注',
    tips: '对医生的备注，只针对健管与健管之间的协同备注。展示最后一次填写的信息。',
    placeholder: '输入协同备注后，能同步给健管知晓',
    keyword: '',
    maxLength: 200
  }
}
